export const PALIKA = "PALIKA";
export const SIGNATURE = "SIGNATURE";
export const STAMP = "STAMP";
export const LOGO = "LOGO";
export const SIGNATURE_OF_LOCAL_GOVERNMENT_HEAD = "SIGNATURE_OF_LOCAL_GOVERNMENT_HEAD"

//TODO: bikash --OTHER is a constant-keep it in constant later
export const FEEDBACK_SUBJECTS = [
  { value: "CLIENT_SERVICE_RELATED", label: "सामान्य ग्राहक सेवा" },
  { value: "SUGGESTIONS", label: "सुझावहरु" },
  { value: "SOFTWARE_RELATED", label: "सफ्टवेर सम्बन्धि जानकारी" },
  { value: "OTHER", label: "अन्य" }
];

export const OFFICE_TYPES = [
  { value: PALIKA, label: "पालिका" },
  { value: "GOVERNMENTAL_ORGANIZATION", label: "अन्य सरकारी संस्था " },
];

export const EMPLOYEE_TYPE = [
  { value: "PERMANENT", label: "स्थाई" },
  { value: "TEMPORARY", label: "अस्थायी" },
  { value: "KARAR", label: "करार" },
  { value: "JYALADARI", label: "ज्यालादारी" },
  { value: "OTHER", label: "अन्य" }
];

export const WORKING_OFFICE_TYPE = [
  { value: "MUNICIPALITY", label: "नगरपालिका/गाउँपालिका" },
  { value: "WARD", label: "वडा कार्यालय" },
  { value: "HEALTH_INSTITUTION", label: "स्वास्थ्य संस्था" },
  { value: "SCHOOL", label: "विद्यालय" },
  { value: "OTHER", label: "अन्य" },
]
